import {
  TListWorkflowExecutionsQueryParams,
  TListWorkflowExecutionsResponse,
} from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { WORKFLOW_EXECUTION_BASE_URL } from './helpers';

export const useWorkflowExecutions = (
  queryParams?: TListWorkflowExecutionsQueryParams
) => {
  const query = new URLSearchParams();
  if (queryParams?.ids) query.append('ids', queryParams.ids.join(','));
  if (queryParams?.name) query.append('name', queryParams.name);
  if (queryParams?.workflowTemplateVersionId)
    query.append(
      'workflowTemplateVersionId',
      queryParams.workflowTemplateVersionId
    );
  if (queryParams?.parentWorkflowExecutionId)
    query.append(
      'parentWorkflowExecutionId',
      queryParams.parentWorkflowExecutionId
    );
  if (queryParams?.rootWorkflowExecutionId)
    query.append(
      'rootWorkflowExecutionId',
      queryParams.rootWorkflowExecutionId
    );

  const url = `${WORKFLOW_EXECUTION_BASE_URL}/list?${query.toString()}`;

  const { data, error, isLoading, mutate } =
    useSWR<TListWorkflowExecutionsResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
